import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const useDetailsTabs = props => {
  const admaterial = useSelector(state => state.admaterial)
  const translations = useSelector(state => state.translations)
  const preflightReport = useSelector(state => state.preflightReport)

  return { admaterial, translations, preflightReport};
};

export default useDetailsTabs;



// WEBPACK FOOTER //
// ./src/components/Details/Tabs/useDetailsTabs.js